import { useState } from 'react';

interface Props {
  publicationIds: string[];
}

const useSelectedPubs = ({ publicationIds }: Props) => {
  const [selectedPubsIds, setSelectedPubsIds] = useState<any>([]);
  const isAllSelected = selectedPubsIds.length === publicationIds.length;

  const onToggle = (id: string) => {
    if (selectedPubsIds.includes(id)) {
      return setSelectedPubsIds(selectedPubsIds.filter((s: string) => s !== id));
    }

    setSelectedPubsIds([...selectedPubsIds, id]);
  };

  const deselectAll = () => setSelectedPubsIds([]);
  const selectAll = () => setSelectedPubsIds(publicationIds);

  const handleBulkToggle = () => {
    if (isAllSelected) return deselectAll();

    selectAll();
  };

  return {
    selectedPubsIds,
    onToggle,
    isAllSelected,
    handleBulkToggle,
  };
};

export default useSelectedPubs;
